import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App'; // Import AppLoader instead
import { AppLoader } from './AppLoader'; // Use named import
import reportWebVitals from './reportWebVitals';

// Disable console.log in production for performance
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  // Keep console.error for critical errors
}

console.log('[index.tsx] Script start'); // <-- Log 1

const rootElement = document.getElementById('root');

if (rootElement) {
  console.log('[index.tsx] Found root element'); // <-- Log 2
  const root = ReactDOM.createRoot(rootElement as HTMLElement);
  
  console.log('[index.tsx] Rendering <AppLoader />...'); // Update log message
  root.render(
    <React.StrictMode>
      <AppLoader /> { /* Render AppLoader here */ }
    </React.StrictMode>
  );
  console.log('[index.tsx] Render call complete'); // <-- Log 4
} else {
  console.error('[index.tsx] Root element #root not found in the DOM!');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
console.log('[index.tsx] Script end'); // <-- Log 5
